module.exports = " <a v-if=active v-bind:href=link :style=style class=ad> <img v-if=show class=logo v-bind:src=src role=presentation> <div class=content> <div class=title>{{title}}</div> <div class=desc><slot></slot></div> </div> <span v-bind:click=close class=close>×</span> </a> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Ad.vue
// module id = 118
// module chunks = 1